import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchLanguagesThunk: any = createAsyncThunk<IEntityBase[]>(
  `${prefix} fetchLanguages`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getLanguages();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch languages. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
